export const formatNumberWithCommas = (value: number | string): string => {
  if (value === undefined || value === null) return '';
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const parseNumberWithCommas = (value: string): number => {
  if (!value) return 0;
  return Number(value.replace(/,/g, ''));
}; 